import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode } from 'src/app/components/att-casting-view/att-casting-view.component';

@Injectable({
	providedIn: 'root'
})
export class TextQualifierService implements Qualifier {
	static supportedStats = ['count', 'first', 'last', 'max', 'median', 'min', 'sum'];
	static FromString(value: string, format: CastingTypeFormat): string {
		format = format;
		return value;
	}
	static ToString(value: string, format: CastingTypeFormat): string {
		format = format;
		return value;
	}

	constructor() { }
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		attribute = attribute;
		castingMode = castingMode;
		return val;
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null].indexOf(val) > -1) {
			return '';
		}
		return val;
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return TextQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName): boolean {
		return TextQualifierService.supportedStats.indexOf(statName) > -1;
	}
	public static GetNumFormat(attribute: AttributeInfo, castingMode: CastingMode): any {
		return '@';
	}
}
